<div class="selector-container" [ngStyle]="{ 'width':width }">
  <div class="select-custom"
    [ngClass]="{ 'focused' : focused }"
    (click)="toggleFocus()"
    (mouseenter)="onMouseOver()"
    (mouseleave)="onMouseLeft()">
    @if (selectedIndex.length == 0) {
      <div class="selected-item placeholder"
        >
        {{ placeHolder }}
      </div>
    }
    @if (selectedIndex.length > 0) {
      <div class="selected-items"
        >
        @for (i of selectedIndex; track i) {
          <div (click)="$event.stopPropagation();">
            {{ items[i].name }}
            <img src="assets/img/icons/new_icons/cancel_white.png"
              (click)="removeItem(i,$event)">
            </div>
          }
          @if ( selectedIndex.length -1 > 0) {
            <p class="select-count"
              >
              {{ '+' + (selectedIndex.length -1) }}
            </p>
          }
        </div>
      }
      <i class="arrow-down"
        (click)="toggleFocus()"
      [ngClass]="{ 'arrow-focused' : hovered || focused }"></i>
    </div>
    @if (focused) {
      <div class="select-custom-options"
        (mouseleave)="hideDropdown()"
        >
        @if (showSelectAll) {
          <div (click)="toggleSelectAll()">
            <input type="checkbox"
              class="checkbox"
              [(ngModel)]="selectAll"
              (ngModelChange)="onSelectAll()"/>
              <div>Select All</div>
            </div>
          }
          @for (i of items; track i; let index = $index) {
            @if ( i.rating > 0) {
              <div (click)="onItemSelected(index)">
                <input type="checkbox"
                  [checked]=" selectedIndex.includes(index)"/>
                  @for ( x of [].constructor(i.rating); track  x) {
                    <img    class="star-rating"
                      src="assets/img/icons/new_icons/cb_star_active.svg" alt="">
                    }
                    @for ( x of [].constructor(maxRating-i.rating); track  x) {
                      <img    class="star-rating"
                        src="assets/img/icons/new_icons/cb_star_inactive.svg" alt="">
                      }
                    </div>
                  }
                  @if ( i.rating == 0) {
                    <div (click)="onItemSelected(index)">
                      <input type="checkbox"
                        [checked]=" selectedIndex.includes(index)"/>
                        <div>No Rating</div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
